import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getInvoices = async () => {
  const response = await axiosInstance.get('Invoices/get-invoices');
  return response.data;
};

export const getInvoiceById = async (id) => {
  const response = await axiosInstance.get(`Invoices/get-invoice/${id}`);
  return response.data;
};

export const addInvoice = async (invoice) => {
  const response = await axiosInstance.post('Invoices/add-invoice', invoice);
  return response.data;
};

export const updateInvoice = async (id, invoice) => {
  const response = await axiosInstance.put(`Invoices/update-invoice/${id}`, invoice);
  return response.data;
};

export const deleteInvoice = async (id) => {
  await axiosInstance.delete(`Invoices/delete-invoice/${id}`);
};

export const getInvoicesByCustomer = async (customerId) => {
  const response = await axiosInstance.get(`Invoices/invoices-by-customer/${customerId}`);
  return response.data;
};

export const getInvoicesByProduct = async (productId) => {
  const response = await axiosInstance.get(`Invoices/invoices-by-product/${productId}`);
  return response.data;
};

export const getOutstandingInvoicesByCustomer = async (customerId) => {
  const res = await axiosInstance.get(`/Invoices/outstanding-invoices-by-customer/${customerId}`);
  return res.data;
};

export default {
  getInvoices,
  getInvoiceById,
  addInvoice,
  updateInvoice,
  deleteInvoice,
  getInvoicesByCustomer,
  getInvoicesByProduct,
  getOutstandingInvoicesByCustomer
};